import { matchRoutes, Navigate, useLocation } from 'react-router-dom';

import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import BasicLayout from 'layouts/authentication/components/BasicLayout';

const PrivateLayout = ({ children }) => {
  const location = useLocation();
  const isBillingPage = matchRoutes([{ path: '/billing' }], location.pathname);
  const localStorageToken = localStorage.getItem('access_token');
  const isVerifyOtpPage = matchRoutes([{ path: '/verify-otp' }], location.pathname);
  const isTempToken = localStorage.getItem('access_token_temp');

  const isLoggedIn = localStorageToken !== null;

  if (isVerifyOtpPage) {
    return isTempToken ? (
      <BasicLayout>
        {children}
      </BasicLayout>
    ) : (
      <Navigate to="/login" replace />
    )
  }

  return !isLoggedIn ? (
    <Navigate to="/login" replace />
  ) : (
    <DashboardLayout>
      {isLoggedIn && (
        <DashboardNavbar
          absolute={Boolean(isBillingPage?.length)}
          isMini={Boolean(isBillingPage?.length)}
        />
      )}{' '}
      {children}
    </DashboardLayout>
  );
};

export default PrivateLayout;
